/** Browser file picker filter — keep in sync with backend acc-document-attachment.storage.ts */
export const ACC_DOCUMENT_ATTACHMENT_ACCEPT =
  '.pdf,.doc,.docx,.xls,.xlsx,.csv,.jpg,.jpeg,.png,.gif,.webp,.bmp,' +
  'application/pdf,application/msword,' +
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
  'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' +
  'text/csv,image/jpeg,image/png,image/gif,image/webp,image/bmp';

export const ACC_DOCUMENT_ATTACHMENT_HINT =
  'PDF, Word, Excel, CSV, or images · max 15 MB each';
